/**
 * basePersistence.js — Ai Base persistence helpers
 *
 * Canonical tenant field: `baseKey`. Writers set `baseKey` only.
 */

function cleanKey(value) {
  return typeof value === 'string' ? value.trim() : '';
}

/**
 * Canonical Firestore query field for tenant scoping.
 */
export const TENANT_KEY_FIELD = 'baseKey';

/**
 * Resolve the tenant id from a doc, payload, or mixed object.
 *
 * @param {object|null|undefined} source
 * @returns {string}
 */
export function resolveBaseKey(source) {
  if (!source || typeof source !== 'object') return '';
  return cleanKey(source.baseKey);
}

/**
 * Build tenant key fields for HTTPS callable payloads.
 * Sends canonical `baseKey` only.
 *
 * @param {string} [baseKey]
 * @returns {{ baseKey: string }|{}}
 */
export function buildTenantCallableFields(baseKey) {
  const key = cleanKey(baseKey);
  if (!key) return {};
  return { baseKey: key };
}

/**
 * Build a tenant-key patch (`baseKey` only).
 *
 * @param {string} baseKey
 * @returns {{ baseKey: string }|null}
 */
export function buildBaseKeyFields(baseKey) {
  const key = cleanKey(baseKey);
  if (!key) return null;
  return { baseKey: key };
}

/**
 * Merge tenant key onto a data object (shallow copy).
 *
 * @param {object} data
 * @param {string} [explicitBaseKey]
 * @returns {object}
 */
export function withBaseKey(data = {}, explicitBaseKey = '') {
  const key = cleanKey(explicitBaseKey) || resolveBaseKey(data);
  const fields = buildBaseKeyFields(key);
  if (!fields) {
    return { ...data };
  }
  return {
    ...data,
    ...fields,
  };
}
